import { server } from '#config';
import axios from 'axios';
import rollbar from '#services/rollbar';

const DEFAULT_LOCATION = {
  state_prov: null,
  city: null,
  country_code2: 'US',
};

const AXIOS_OPTS = { timeout: 5000 };

/** Same-origin proxy → https://reallyfreegeoip.org/json/{ip} (avoids browser CORS). */
const GEO_PROXY_URL = `${server}/public/geo/ip`;

/** Share of all-provider-failure cases sent to Rollbar (rest silent; reduces noise from transient blocks/timeouts). */
const GEO_ALL_PROVIDERS_FAILED_REPORT_RATE = 0.01;

/** Normalize to our shape { state_prov, city, country_code2 } from either API. */
function toLocationShape(data) {
  const loc = data?.location ?? data;
  const country =
    loc?.country_code2 ?? loc?.country_code;
  return {
    state_prov: loc?.state_prov ?? loc?.region_name ?? null,
    city: loc?.city ?? null,
    country_code2: (country && String(country).trim()) || 'US',
  };
}

/**
 * Get current user location by IP.
 * 1) ipgeolocation.io (frontend key), 2) API proxy → reallyfreegeoip.org/json/{ip}.
 */
export async function getCurrentLocation() {
  try {
    const resp = await axios.get(
      `https://api.ipgeolocation.io/ipgeo?apiKey=${process.env.REACT_APP_IP_GEO_LOCATION_KEY}`,
      AXIOS_OPTS
    );
    return toLocationShape(resp.data);
  } catch (_) {
    try {
      const resp = await axios.get(GEO_PROXY_URL, AXIOS_OPTS);
      return toLocationShape(resp.data?.success?.ipGeo);
    } catch (fallbackErr) {
      if (Math.random() < GEO_ALL_PROVIDERS_FAILED_REPORT_RATE) {
        rollbar.warning('IP geolocation: all providers failed, using default location', {
          ipgeolocation: 'failed',
          reallyfreegeoip: 'failed',
          fallbackError: fallbackErr?.message,
        });
      }
      return DEFAULT_LOCATION;
    }
  }
}
